/**
 * Professional theme preset
 * Clinical, trustworthy appearance for medical practices
 */

import { ThemeSchema, type Theme } from '../types';
import { DEFAULT_DENSITY } from './base';

export const professionalTheme: Theme = ThemeSchema.parse({
  name: 'professional',
  colors: {
    primary: '#1E3A5F',
    primaryDark: '#152A45',
    primaryLight: '#2C5282',
    accent: '#2E7E51',
    accentDark: '#1F5E3A',
    accentLight: '#48BB78',
    background: '#FFFFFF',
    backgroundAlt: '#F7FAFC',
    surface: '#FFFFFF',
    text: '#2D3748',
    textMuted: '#4A5568',
    textInverse: '#FFFFFF',
    border: '#E2E8F0',
    success: '#2E7E51',
    warning: '#8B5A1A',
    error: '#E53E3E',
    // Medical-specific
    evidenceStrong: '#2E7E51',
    evidenceModerate: '#8B5A1A',
    evidenceLow: '#4A5568',
    safetyWarning: '#E53E3E',
    safetyInfo: '#2C5282',
  },
  typography: {
    fontFamily: '"Source Sans Pro", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    fontFamilyHeading: '"Merriweather", Georgia, serif',
    fontWeightHeading: '700',
    fontSizeBase: '1rem',
    fontSizeSm: '0.875rem',
    fontSizeLg: '1.125rem',
    fontSizeXl: '1.25rem',
    fontSize2xl: '1.5rem',
    fontSize3xl: '1.875rem',
    fontSize4xl: '2.25rem',
    lineHeightBase: '1.5',
    lineHeightTight: '1.25',
    lineHeightLoose: '1.75',
  },
  spacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem',
    '2xl': '3rem',
    '3xl': '4rem',
  },
  borderRadius: {
    none: '0',
    sm: '0.125rem',
    md: '0.25rem',
    lg: '0.375rem',
    xl: '0.5rem',
    full: '9999px',
  },
  shadows: {
    sm: '0 1px 2px 0 rgb(30 58 95 / 0.05)',
    md: '0 4px 6px -1px rgb(30 58 95 / 0.1), 0 2px 4px -2px rgb(30 58 95 / 0.1)',
    lg: '0 10px 15px -3px rgb(30 58 95 / 0.1), 0 4px 6px -4px rgb(30 58 95 / 0.1)',
    xl: '0 20px 25px -5px rgb(30 58 95 / 0.1), 0 8px 10px -6px rgb(30 58 95 / 0.1)',
  },
  // HAL-495: shared layout rhythm + ch-based reading measures. See DEFAULT_DENSITY.
  density: DEFAULT_DENSITY,
});
